import fetch from './fetch.helper.js';

export const fetchUsers = () => fetch('get', 'users');

export const getUserById = (id) => fetch('get', `users/${id}`);

export const postUser = (form) => fetch('post', 'users', null, form);

export const deleteUser = (id) => fetch('delete', `users/${id}`);

export const putUser = (id, changes) => {
  return fetch('put', `users/${id}`, null, changes);
};

export const putUserData = (id, changes) =>
  fetch('put', `users/${id}`, null, changes);

// Self-signup: creates user and auto-logs them in via session
export const signup = async (form) => {
  const email = form.emailAddress.toLowerCase();
  try {
    // POST /users without auth = self-signup with auto-login
    return await postUser({
      ...form,
      emailAddress: email,
    });
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const checkForEmail = (email) =>
  fetch('get', `email/${email.trim().toLowerCase()}`);
